import { init, FullStory } from '@fullstory/browser';
import { isEmailFromTrusted } from './email-helper';
import { ENV_VARS } from '@common/services/env-vars-service';

function fullstorySetUser(user, membership) {
  const { uuid, firstName, lastName, email } = user;
  const { entity: name } = membership;

  FullStory('setIdentity', {
    uid: uuid,
    properties: {
      displayName: [firstName, lastName].join(' '),
      email,
      entityName_str: name,
    },
  });

  const notRecordableUserTypes = [
    user.internalTrustedUser,
    membership.isSupplierUser && isEmailFromTrusted(email),
  ];

  if (notRecordableUserTypes.some(Boolean)) {
    FullStory('shutdown');
  }
}

function initFullStory() {
  const fullstoryOrgId = ENV_VARS.WORKS_FULLSTORY_ORG_ID || 'INVALID';

  init({ orgId: fullstoryOrgId });
}

export { fullstorySetUser, initFullStory };
